import { LeihbarOpeningHoursSettingsTranslation } from 'locales/de/pages/LeihBar/leihbarOpeningHoursSettings';

const en: LeihbarOpeningHoursSettingsTranslation = {
  vacation: {
    vacationTimes: 'Holiday times',
    startDate: 'Startdate',
    endDate: 'Enddate',
    alerts: {
      failedDelete: 'The vacation could not be deleted',
      failedUpdate: 'The vacation could not be saved.',
      failedCreate: 'The vacation could not be created.',
      successfulCreate: 'The vacation has been created.',
      successfulUpdate: 'The vacation has been updated.',
      successfulDelete: 'The vacation has been deleted.',
      vacationSaveSuccessful: 'The vacation was successfully created.',
      loadError: 'The vacations could not be loaded.'
    },
    conflictingBookings:
      'There are already bookings in the selected period. Please take care of the following bookings:',
    confirmDelete: 'Do you really want to delete the vacation?',
    ColorDescription: {
      vacation: 'Vacation',
      booking: 'Booking',
      vacationBooking: 'Vacation and booking'
    }
  },
  lendertimes: {
    availabilityTimes: {
      title: 'PickUp- and Returntimes',
      text1: 'Specify when someone is available by default to issue or receive a product.',
      text2:
        'These times can be overwritten in individual products in the "Available time periods" area with the "Independent of pick-up/return times of the lender" slider.',
      text3:
        'Please note that if the time periods overlap, the larger interval is always taken into account.'
    },
    noLenderTimeAvailable: 'There are no opening hours yet. Please create your first one here: ',
    alerts: {
      failedUpdate: 'The opening hours could not be edited.',
      successfulUpdate: 'The opening hours were successfully processed.'
    }
  }
};

export default en;
